import configData from "../config/config.json";

export async function postUpdatedAccountInfo(authHeaderValue, username, firstname, lastname, emailaddress, phone, roles, managerId, webuserId, userUpdate = false) {
    console.log('this one', webuserId);
    try{
        const url = configData.CCBHTableauAPIServer + "/UpdateAccountInformation?userUpdate=" + userUpdate;
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Authorization':authHeaderValue,
                     'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin':'*',
                     "WebuserID": webuserId
                    },
            body:JSON.stringify({
                    "username": username,
                    "firstName": firstname,
                    "lastName": lastname,
                    "emailAddress": emailaddress,
                    "phone": phone,
                    "managerId": managerId,
                    "roles": [
                        roles
                    ]
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
};

export async function addNewEmployee(authHeaderValue, firstname, lastname, emailaddress, phone, role, managerId){
    try{
        const url = configData.CCBHTableauAPIServer + "/AddNewUser";
        const sessionTableauTrustTicket = window.sessionStorage.getItem("userTableauTrustTicket");
        const sessionSiteId = window.sessionStorage.getItem("userSiteId");
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Authorization':authHeaderValue,
                     'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin':'*',
                     'Ticket': sessionTableauTrustTicket,
                     'SiteId': sessionSiteId
                    },
            body:JSON.stringify(
                {
                    "firstName": firstname,
                    "lastName": lastname,
                    "username": "",
                    "phoneNumber": phone,
                    "email": emailaddress,
                    "title": "string",
                    "managerId": managerId,
                    "roles": [
                      role
                    ],
                    "userType": "",
                    "entites": [
                      {
                        "name": "",
                        "id": "",
                        "type": 0,
                        "typeDescription": "",
                        "role": role,
                        "enabled": true 
                      }
                    ],
                    "lastLoginDate": "",
                    "directReportEmployees": [],
                    "userID": "",
                    "tableauTicket": sessionTableauTrustTicket
                  }
                ),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('Added User: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

export async function postUpdateUserFirstTimeLogin(authHeaderValue, username, firstname, lastname, emailaddress, phone, password){
    try{
        const url = configData.CCBHTableauAPIServer + "/updatefirsttimelogin";
        const sessionTableauTrustTicket = window.sessionStorage.getItem("userTableauTrustTicket");

        const response = await fetch(url, {
            method: "POST",
            headers:{'Authorization':authHeaderValue,
                     'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin':'*',
            },
            body:JSON.stringify({
                    "username": username,
                    "firstName": firstname,
                    "lastName": lastname,
                    "emailAddress": emailaddress,
                    "phone": phone,
                    "password": password,
                    "managerId": 'managerId',
                    "roles": [ ]
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update first time: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
};

export async function postResetPassword(authHeaderValue, username){
    try{
        const url = configData.CCBHTableauAPIServer + "/password/reset";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Authorization':authHeaderValue,
                     'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin':'*',
            },
            body:JSON.stringify({
                    "webuserID": username,
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update first time: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
        return {success: false, data: ['401']};
    } 
};